<template>
    <div>
        <!-- 表格 -->
        <el-table class="columnClassNav" align="center" :data="tableData" v-loading="loading" stripe border max-height="420" empty-text="暂无变动记录">
            <el-table-column label="变动艺钻" min-width="130" prop="changeAmount" align="center">
                <template slot-scope="tableData">
                    <span :style="{ color: signedAmount(tableData.row) >= 0 ? '#5eb95e' : '#f04134' }">
                        <span>{{ signedAmount(tableData.row) > 0 ? '+' : '' }}</span>
                        <span>{{ signedAmount(tableData.row).toFixed(2) }}</span>
                    </span>
                </template>
            </el-table-column>

            <el-table-column label="变动来源" min-width="140" prop="changeAmount" align="center">
                <template slot-scope="tableData">
                    <el-tag>
                        {{ tableData.row.sourceType == 'RECHARGE' ? '充值' : tableData.row.sourceType == 'WITHDRAW' ? '提现'
                            : tableData.row.sourceType == 'GIFT' ? '赠送礼物' : tableData.row.sourceType == 'RECEIVE_GIFT' ?
                        '接收礼物' : tableData.row.sourceType == 'SYSTEM_OPERATE' ? '系统操作' :
                        tableData.row.sourceType == 'BALANCE_EXCHANGE_POINTS' ? '艺钻兑换积分' : '未知' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="变动前艺钻" min-width="130" align="center" prop="beforeAmount">
            </el-table-column>

            <el-table-column prop="afterAmount" label="变动后艺钻" min-width="130" align="center">
            </el-table-column>

            <el-table-column prop="createTime" label="变动时间" min-width="180" align="center">
            </el-table-column>
        </el-table>

        <div style="text-align: right;margin: 20px 20px 0 0;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="total_pages">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import '@/assets/icon/iconfont.css'
import { getBalanceRecordPage } from '@/api/withdraw'
export default {
    name: 'messageList',
    props: {
        userId: { type: [Number, String], default: 0 },
        nickName: { type: String, default: '' },
    },
    data() {
        return {
            tableData: [],
            loading: false,
            // 对话框
            total_pages: 0,
            params: { pageNum: 1, pageSize: 10 },
        }
    },
    created() {
        this.getData()
    },
    methods: {
        signedAmount(row) {
            const amount = Number(row.changeAmount || 0)
            if (row.type === 'REDUCE') return -Math.abs(amount)
            if (row.type === 'INCREASE') return Math.abs(amount)
            return amount
        },
        getData() {
            this.loading = true;
            this.params.userid = this.userId;
            getBalanceRecordPage(this.params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.total_pages = res.data.total;
                } else {
                    this.$message.error(res.msg || '获取艺钻明细失败');
                }
            }).catch((err) => {
                this.$message.error(err ? err : '获取礼物记录列表失败');
            }).finally(() => { this.loading = false })
        },
        handleCurrentChange(number) {
            this.params.pageNum = number;
            this.getData();
        },
        handleSizeChange(size) {
            this.params.pageSize = size;
            this.params.pageNum = 1;
            this.getData();
        }
    }
}
</script>

<style scoped lang="scss">
.elTableBox {
    display: flex;
    width: 100%;
}
</style>
